import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { getDataTicket } from '../../service/callAPI'
import schema from './schema'
// import attention from '../../data/attentionData.json'
// import QrScanner from 'qr-scanner'

import { Container, Box, Paper, Button, TextField, CircularProgress } from '@mui/material'
import LogoBrand from '../../components/LogoBrand'
import QRReader from '../../components/QRReader'
import Snackbar from '../../components/Snackbar'

function RegisFirstPage() {
  const [focused, setFocused] = useState(false)
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [alert, setAlert] = useState({
    open: false,
    status: 'success',
    message: 'This is a success message!',
  })
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      code: '',
    },
  })
  // const isCode = watch('code')
  const onSubmit = async (values) => {
    setIsLoading(true)
    // console.log('onSubmit', values)
    // window.location.href = `information?qrcode=${values.code}`
    getDataTicket({
      action: 'da999d7a-c164-a21a-bcf7-32cb27298727',
      actionType: 'check',
      code: values.code,
      event_id: 'da999d7a-c164-a21a-bcf7-32cb27298727',
    })
      .then((res) => {
        console.log('then', res)
        if (res.code === 0) {
          setIsLoading(false)
          localStorage.setItem('code', JSON.stringify({ code: values.code }))
          window.open(`https://sohr.sprout.ph/event-app/`, '_blank')
          // window.open(`event?qrcode=${values.code}`, '_blank')
          // window.location.href = `event?qrcode=${values.code}`
        } else {
          if (res.code === 97) {
            // ticket "already register"
            if (res.data.pre_detail) {
              localStorage.setItem('code', JSON.stringify({ code: values.code }))
              window.open(`https://sohr.sprout.ph/event-app/`, '_blank')
              // window.location.href = `event?qrcode=${values.code}`
            } else {
              setAlert({
                open: true,
                status: 'error',
                message: 'Already register',
              })
              setIsLoading(false)
            }
          } else if (res.code === 123 || res.code === 124) {
            //please confirm email show alert
            setAlert({
              open: true,
              status: 'warning',
              message: 'Wait for user confirm mail',
            })
            setIsLoading(false)
          } else {
            console.log('unknow error @alert')
            setAlert({
              open: true,
              status: 'error',
              message:
                'The email address you entered is not registered. Please proceed to the registration booth/help desk for assistance.',
            })
            setIsLoading(false)
          }
        }
      })
      .catch((rese) => {
        console.log(rese)
        console.log('unknow error @alert')
        setIsLoading(false)
        setAlert({
          open: true,
          status: 'error',
          message: 'Unknow error',
        })
      })
  }
  let propsInput = {}
  if (focused) {
    propsInput = {
      focused: true,
    }
  }
  // console.log('errors', errors)

  return (
    <Container maxWidth="sm" sx={{ height: '100vh' }}>
      <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box>
          <LogoBrand />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Paper
              elevation={0}
              customBorder
              sx={{
                p: 4.5,
              }}
            >
              <Box>
                <Controller
                  control={control}
                  name="code"
                  render={({ field }) => {
                    return (
                      <TextField
                        {...field}
                        id="input-code"
                        name="code"
                        label="Enter email"
                        placeholder="Enter email here"
                        variant="standard"
                        error={errors?.code}
                        helperText={errors?.code?.message}
                        fullWidth
                        sx={{
                          '& .MuiInputLabel-root': {
                            color: '#33475b!important',
                          },
                          '& .MuiInput-root': {
                            color: '#33475b!important',
                          },
                          '& .Mui-focused': {
                            color: '#33475b',
                          },
                          '& :before': {
                            borderBottom: '1px solid #33475b!important',
                          },
                          '& :after': {
                            borderBottom: '2px solid #33475b!important',
                          },
                        }}
                        {...propsInput}
                      />
                    )
                  }}
                />
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ mt: 4, '&.Mui-disabled': { backgroundColor: 'rgba(255, 255, 255, 0.2)' } }}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} sx={{ color: '#17ad49' }} /> : 'Submit'}
                </Button>
              </Box>
            </Paper>
          </form>
          <QRReader
            open={open}
            onClose={() => setOpen((prev) => !prev)}
            onScan={(value) => {
              setValue('code', value)
              setFocused(true)
              console.log('onScan', value)
            }}
          />
          <Snackbar
            isOpen={alert.open}
            onClose={setAlert}
            severity={alert.status}
            message={alert.message}
          />
        </Box>
      </Box>
    </Container>
  )
}

export default RegisFirstPage
